/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: pfy
 * @Date: 2019-07-22 18:59:18
 * @LastEditTime: 2019-09-17 14:18:49
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  被邀请管理接口Url
const findPageCoverInvitationUrl = '/website/warehousing/invitation'

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

/* 预约看仓 */
const appointmentUrl = `/website/storage/appointment`

/* 预约看仓 */
export function appointment(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + appointmentUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'appointmentSave'
      }, param))
    }
  })
}

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}

// 分页查询被邀请需求列表
export function findPageCoverInvitation(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + findPageCoverInvitationUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageCoverInvitation'
      }, param))
    }
  })
}

// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 修改邀请状态
export function updateStatus(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + 'website/warehousing/invitation',
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'updateStatus'
      }, param))
    }
  })
}
